import { IAgendaItem } from '@/shared/api-client/models/agenda/agenda-item';
import { IFileArchiveFile } from '@/shared/api-client/models/file-archive-file';
import { IHierarchyNode } from '@/shared/api-client/models/hierarchy-node';
import { ConsoleFacade } from '@/shared/helpers';
import { ArgumentValidator } from '@/shared/helpers/argument-validator';
import { Urls } from '@/shared/helpers/urls';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { UIEventHandler } from '@/shared/helpers/ui-event-handler';
import { ActivityStatus } from '@/shared/api-client/enums/activity-status';

@Component
export default class AgendaHierarchyItemComponent extends Vue {

    @Prop() public node!: IHierarchyNode<IAgendaItem>;
    @Prop() public activityId!: string;
    @Prop() public activityStatus!: ActivityStatus | undefined;
    @Prop({ default: undefined }) public currentUserId!: string;
    @Prop({ default: false }) isSpectator!: boolean;
    @Prop({ default: false }) speakerQueuesEnabled!: boolean;
    @Prop() public translations!: { [key: string]: string; };
    @Prop({ default: null }) public activeAgendaItemId!: string;
    @Prop({ default: [] }) public handledAgendaItemIds!: string[];

    @Emit('agendaItemSpeechDialogClicked') public emitAgendaItemSpeechDialogClicked(item: IAgendaItem): string {
        ArgumentValidator.notNullOrEmpty(item, `item`);
        return item.id;
    }

    @Emit('agendaItemSpeechQueueDialogClicked') public emitAgendaItemSpeechQueueDialogClicked(item: IAgendaItem): string {
        ArgumentValidator.notNullOrEmpty(item, `item`);
        return item.id;
    }

    public get hasActiveItem(): boolean {

        return !!this.activeAgendaItemId;
    }

    public get isActive(): boolean {

        return this.node.entity.id.toLowerCase() === (this.activeAgendaItemId ? this.activeAgendaItemId.toLowerCase() : null);
    }

    public get isFinished(): boolean {

        return this.activityStatus === 'Finished';
    }

    public get isPreviousAgendaItem(): boolean {

        if (this.isActive) {
            return false;
        }

        return this.handledAgendaItemIds.find(x => x.toLowerCase() === this.node.entity.id.toLowerCase()) !== undefined;
    }

    public get isUnhandledAgendaItem(): boolean {

        return this.handledAgendaItemIds.every(x => x.toLowerCase() !== this.node.entity.id.toLowerCase());
    }

    public get showDecriptionWrapper(): boolean {

        return (!!this.node.entity.description || (this.node.entity.fileArchiveFiles && this.node.entity.fileArchiveFiles.length > 0) || false);
    }

    public openAgendaItemSpeechDialog($event: UIEvent): void {

        UIEventHandler.preventDefaults($event);

        this.emitAgendaItemSpeechDialogClicked(this.node.entity);
    }

    public openAgendaItemSpeechQueueDialog($event: UIEvent): void {

        UIEventHandler.preventDefaults($event);

        this.emitAgendaItemSpeechQueueDialogClicked(this.node.entity);
    }

    public downloadUrl(file: IFileArchiveFile): string {

        ArgumentValidator.notNullOrEmpty(file, `file`);

        const fileSrc = Urls.fileArchiveDownloadFile(file.id);

        ConsoleFacade.log(`Downloading file`, fileSrc);

        return fileSrc;
    }
}